import useSharedShowPageContext from '../common/hooks/useSharedShowPageContext';
import useShow from '../../../../hooks/shows/useShowFromURL';
import RelatedRow from './RelatedSection';
import AboutSection from './AboutSection';
import EpisodesSection from './EpisodesSection';
import styles from './styles.module.scss';
import HeroShowContent from './HeroShowContent';
import HeroShiftedPageContent from '@/components/app/ShowHeroDesktop/HeroShiftedPageContent';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import LayoutWrapperVertical from '@/components/component-library/LayoutWrapperVertical';
import ShowHeroDesktop from '@/components/app/ShowHeroDesktop/HeroShow';

const ShowPageDesktop = () => {
  const { relatedRowImpressionRef } = useSharedShowPageContext();

  const { show, isLoading } = useShow();

  return (
    <LayoutWrapperVertical
      className={ styles.showPageDesktop }
      disableBottomOnDesktop
      disableTopOnDesktop
    >
      <ShowHeroDesktop enableLeftGradient isLoading={ isLoading } show={ show }>
        <HeroShowContent />
      </ShowHeroDesktop>
      <HeroShiftedPageContent>
        <LayoutWrapperVertical
          disableTopOnDesktop
          extraPagePadding
        >
          <div className={ styles.showContentDesktop }>
            <LayoutWrapperHorizontal>
              <div
                className={ styles.showTopSection }
                id='desktop-channel-top-section'
              >
                <EpisodesSection />
                <div className={ styles.aboutSpacer } />
                <AboutSection />
              </div>
            </LayoutWrapperHorizontal>
            <div
              className={ styles.showBottomSection }
              ref={ relatedRowImpressionRef }
            >
              <RelatedRow />
            </div>
          </div>
        </LayoutWrapperVertical>
      </HeroShiftedPageContent>
    </LayoutWrapperVertical>
  );
};

export default ShowPageDesktop;